import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, getMeta } from "../lib/api";
import { fmtMoney } from "../lib/format";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authState, setAuthState] = useState("checking"); // checking | authed | guest
  const [currency, setCurrency] = useState("INR");
  const [usdInr, setUsdInr] = useState(83.5);
  const [macro, setMacro] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setAuthState("authed");
    } catch {
      setUser(null);
      setAuthState("guest");
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return; // AuthCallback handles it
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    getMeta().then((m) => { setUsdInr(m.usd_inr); setMacro(m.macro); }).catch(() => {});
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("session_token");
    setUser(null);
    setAuthState("guest");
    window.location.href = "/";
  };

  const money = (valInr, opts) => fmtMoney(valInr, currency, usdInr, opts);

  return (
    <AppCtx.Provider value={{
      user, setUser, authState, setAuthState, checkAuth, logout,
      currency, setCurrency, usdInr, macro, money,
    }}>
      {children}
    </AppCtx.Provider>
  );
}
